import { mutationOptions } from '@tanstack/react-query';
import type { UseMutationOptions } from '@tanstack/react-query';

import apiClient from '@/constants/http';
import { Logger } from '@/utils/logging';

import type {
  ValidateBarberPasscodePayload,
  ValidateBarberPasscodeResponse,
} from './types';

async function validateBarberPasscode(
  payload: ValidateBarberPasscodePayload,
): Promise<ValidateBarberPasscodeResponse> {
  try {
    const response = await apiClient.post<ValidateBarberPasscodeResponse>(
      `/v1/barber/validate/${payload.barberId}`,
      { passcode: payload.passcode },
    );

    return response.data;
  } catch (error) {
    Logger.error('Failed to validate barber passcode', {
      barberId: payload.barberId,
      error,
    });
    throw error;
  }
}

export const validateBarberPasscodeMutation = (
  options?: UseMutationOptions<
    ValidateBarberPasscodeResponse,
    Error,
    ValidateBarberPasscodePayload
  >,
) =>
  mutationOptions({
    mutationFn: validateBarberPasscode,
    mutationKey: ['validateBarberPasscode'],
    retry: false,
    ...options,
  });
